import React, { useState, useEffect, useMemo } from "react";
import { BsFillBookmarkFill, BsBookmark } from "react-icons/bs";
import { HiOutlineDownload } from "react-icons/hi";
import { IoIosArrowForward } from "react-icons/io";
import {
  AiFillInstagram,
  AiFillTwitterSquare,
  AiFillLinkedin,
} from "react-icons/ai";
import { FaGithubSquare } from "react-icons/fa";
import { saveAs } from "file-saver";
import { motion } from "framer-motion";
import { Link, useNavigate } from "react-router-dom";
import PostComments from "./postComments";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  setDoc,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebase-config";
import { UserAuth } from "../context/authContext";

const Post = ({
  publishedBy,
  profilePic,
  datePublished,
  title,
  content,
  tumbnailURL,
  pdfName,
  pdfURL,
  instaURL,
  twitterURL,
  linkedinURL,
  githubURL,
  about,
  occupation,
  postId,
  publishedId,
  caption,
  postCategory,
  context,
}) => {
  const handleDownload = () => {
    saveAs(pdfURL, pdfName);
  };

  const getShortBio = (unparsedText) => {
    let newText = unparsedText.substring(0, 100) + "...";
    return newText;
  };

  const [bookmarked, setBookmarked] = useState(null);
  const [save, setSave] = useState(null);

  const { user } = UserAuth();

  const checkIfExists = async () => {
    const docRef = doc(db, "users", user.uid, "Bookmarks", postId);

    const snap = await getDoc(docRef);

    if (!snap.exists || snap.data() === undefined) {
      setSave(false);
    } else {
      setSave(true);
    }
  };

  useEffect(() => {
    checkIfExists();
  }, []);

  const handleBookmark = async () => {
    const docRef = doc(db, "users", user.uid, "Bookmarks", postId);

    const getoc = await getDoc(docRef);

    if (bookmarked === true) {
      await setDoc(docRef, {
        postID: postId,
        postCategory: postCategory,
        postPic: tumbnailURL,
        postPublisher: publishedId,
        name: publishedBy,
        profPic: profilePic,
        title: title && title,
      });
    } else if (bookmarked === false) {
      if (getoc.exists) {
        await deleteDoc(docRef);

        const dummy = "dummy";

        const deleteDummy = doc(db, "users", user.uid, "Bookmarks", dummy);

        await deleteDoc(deleteDummy);
      }
    }
  };

  useEffect(() => {
    handleBookmark();
  }, [bookmarked]);

  let navigate = useNavigate();

  const routeChange = (name, userID) => {
    const replaced = name.replace(" ", "");
    const nav = `/profile/@${replaced}`;
    navigate(nav, { state: { userID: userID } });
  };

  return (
    <motion.div
      key={""}
      className="h-[40rem] w-full flex flex-row p-3 bg-[#131313] rounded-xl justify-between"
      animate={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: 30 }}
      transition={{ ease: "easeOut", duration: 0.5 }}
    >
      <div className="postsInfo h-full flex flex-col w-[68%] justify-between">
        <div className="h-[10%] m w-full mb-3 flex flex-row items-center">
          <div className="postUser w-full flex flex-row justify-between">
            <div className="flex flex-row">
              <div
                className="w-12 h-12 rounded-full mr-3"
                onClick={() => routeChange(publishedBy, publishedId)}
              >
                <img
                  src={profilePic}
                  referrerPolicy="no-referrer"
                  alt="profile"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
              <div className="flex flex-col justify-between">
                <div>
                  <span
                    className="text-zinc-100 font-semibold text-[1.075rem] capitalize"
                    onClick={() => routeChange(publishedBy, publishedId)}
                  >
                    {publishedBy}
                    {occupation && ","}
                  </span>
                  <span className="ml-1">{occupation}</span>
                </div>
                <div className="text-OrangyRed text-sm">{datePublished}</div>
              </div>
            </div>
            {bookmarked || save ? (
              <BsFillBookmarkFill
                size={30}
                className="self-center fill-OrangyRed animate-scale transition ease-in-out hover:scale-110 cursor-pointer"
                onClick={() => {
                  setBookmarked(false);
                  setSave(false);
                }}
              />
            ) : (
              <BsBookmark
                size={30}
                className="self-center fill-zinc-300 animate-scale transition ease-in-out hover:scale-110 cursor-pointer"
                onClick={() => {
                  setBookmarked(true);
                  setSave(true);
                }}
              />
            )}
          </div>
        </div>
        <div
          className={
            pdfName
              ? "h-[77%] w-full p-4 bg-[#181818] rounded-lg overflow-auto mb-3"
              : "h-[88%] w-full p-4 bg-[#181818] rounded-lg overflow-auto"
          }
        >
          <div className="text-xl font-semibold text-white flex-wrap mb-5">
            {title}
          </div>
          {tumbnailURL ? (
            <div className="w-full rounded-xl h-80 mb-4 overflow-hidden bg-[#161616]">
              <img
                src={tumbnailURL}
                alt="post's tumbnail"
                className="object-cover h-full w-full "
              />
            </div>
          ) : (
            <></>
          )}
          <div className="text-zinc-200">{content}</div>
        </div>
        {pdfName && (
          <div className="h-[11%] w-full bg-[#181818] rounded-lg overflow-hidden flex items-center">
            <button
              onClick={handleDownload}
              className="w-fit p-4 bg-[#202020] rounded-lg ml-4 flex flex-row text-zinc-300 hover:scale-105 transition duration-300 ease-in-out"
            >
              {pdfName}
              <HiOutlineDownload size={25} className="ml-4" />
            </button>
          </div>
        )}
      </div>
      <div className="w-[31%] h-full flex flex-col p-0 justify-between gap-3">
        <div className="w-full h-fit bg-[#181818] rounded-lg flex flex-col justify-between">
          <div className="w-full flex flex-row py-3 px-2 items-center">
            <div
              className={
                instaURL || twitterURL || linkedinURL || githubURL || occupation
                  ? "w-20 h-20 rounded-full mr-2"
                  : "w-14 h-14 rounded-full mr-2 "
              }
              onClick={() => routeChange(publishedBy, publishedId)}
            >
              <img
                src={profilePic}
                referrerPolicy="no-referrer"
                className="w-full h-full object-cover rounded-full cursor-pointer"
                alt="profile"
              />
            </div>
            <div>
              <div
                className="font-semibold text-zinc-100 capitalize cursor-pointer"
                onClick={() => routeChange(publishedBy, publishedId)}
              >
                {publishedBy}
              </div>
              {occupation && (
                <div className="text-sm text-zinc-400">{occupation}</div>
              )}
              {instaURL || twitterURL || linkedinURL || githubURL ? (
                <div className="flex flex-row items-center mt-2 gap-1">
                  {instaURL && (
                    <a
                      href={instaURL}
                      rel="noreferrer"
                      target="_blank"
                      className="transition ease-in-out hover:scale-110 cursor-pointer"
                    >
                      <AiFillInstagram size={25} className="fill-OrangyRed" />
                    </a>
                  )}
                  {twitterURL && (
                    <a
                      href={twitterURL}
                      target="_blank"
                      rel="noreferrer"
                      className="transition ease-in-out hover:scale-110 cursor-pointer"
                    >
                      <AiFillTwitterSquare
                        size={25}
                        className="fill-OrangyRed"
                      />
                    </a>
                  )}
                  {linkedinURL && (
                    <a
                      href={linkedinURL}
                      target="_blank"
                      rel="noreferrer"
                      className="transition ease-in-out hover:scale-110 cursor-pointer"
                    >
                      <AiFillLinkedin size={25} className="fill-OrangyRed" />
                    </a>
                  )}
                  {githubURL && (
                    <a
                      href={githubURL}
                      target="_blank"
                      rel="noreferrer"
                      className="transition ease-in-out hover:scale-110 cursor-pointer"
                    >
                      <FaGithubSquare size={23} className="fill-OrangyRed" />
                    </a>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          {about ? (
            <div className="w-full px-2 text-zinc-300">
              {getShortBio(about)}
            </div>
          ) : (
            <></>
          )}
          <div className="w-full px-2 py-2 transition ease-in-out hover:scale-105 hover:translate-x-2">
            <div
              to={""}
              className="w-full flex flex-row text-zinc-600 items-center cursor-pointer"
              onClick={() => routeChange(publishedBy, publishedId)}
            >
              Check out my articles
              <IoIosArrowForward size={20} className="fill-zinc-600" />
            </div>
          </div>
        </div>
        <div className="w-full flex-1 bg-[#181818] rounded-lg overflow-hidden">
          <PostComments
            postID={postId}
            publishedBy={publishedBy}
            postedByPic={profilePic}
            caption={caption}
            publishedId={publishedId}
            postCategory={postCategory}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Post;
